import { h } from 'vue';
import MaterialSymbolsIcon from '~/components/common/icon-sets/materialSymbolsIcon';

/**
 * Material Symbols outlined icon set
 */
const msOutlined = {
  component: (props) => h(
    MaterialSymbolsIcon,
    {
      ...props,
      baseClass: 'material-symbols-outlined', // Override base class
    },
  ),
};

export default msOutlined;
